import { Link } from 'react-router-dom';

export default function SmsTerms() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="bg-navy h-2" />
      <div className="bg-crimson h-1" />
      <div className="flex-1 px-4 py-10">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <div className="section-eyebrow">Utility Trailer of California</div>
            <h1 className="text-3xl font-bold mt-2">SMS Terms &amp; Conditions</h1>
            <div className="rule-crimson" />
            <p className="text-muted text-sm mt-2">Last updated: May 1, 2026</p>
          </div>

          <div className="card p-6 space-y-6 text-sm leading-relaxed text-navy">
            <section>
              <h2 className="text-lg font-semibold mb-2">1. Program description</h2>
              <p>
                The UTSales SMS notification program (the &quot;Program&quot;)
                is operated by John Adams &amp; Associates LLC on behalf of
                Utility Trailer of California (&quot;UTofCA&quot;). It sends
                internal text-message notifications to UTofCA Business
                Development Manager (&quot;BDM&quot;) employees
                who have voluntarily enrolled. Message types include:
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>High-priority customer activity alerts.</li>
                <li>Weekly recap reminders.</li>
                <li>Escalation pings when an in-app or push notification has
                    not been acknowledged.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">2. How to opt in</h2>
              <p>
                Employees opt in inside the UTSales web application by
                entering their mobile number on the Settings/Profile screen
                and checking the SMS consent box. The consent disclosure
                shown at sign-up explains message types, frequency, fees,
                STOP/HELP keywords, and this contact information. The opt-in
                is recorded with a server-side timestamp and IP address.
                Enrollment is voluntary; no purchase is required, and
                opting out of SMS does not affect any other part of the
                Service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">3. Message frequency</h2>
              <p>
                Message frequency is variable and depends on activity in your
                accounts. Most enrolled users receive fewer than 10 messages
                per week.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">4. Costs</h2>
              <p>
                <b>Message and data rates may apply.</b> UTSales does not
                charge for SMS, but your wireless carrier&apos;s standard
                messaging and data rates apply to each message sent and
                received. Contact your wireless carrier for details about
                your plan.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">5. How to opt out (STOP)</h2>
              <p>
                Reply <b>STOP</b>, <b>STOPALL</b>, <b>UNSUBSCRIBE</b>,
                <b> CANCEL</b>, <b>END</b>, <b>QUIT</b>, <b>OPTOUT</b>, or{' '}
                <b>REVOKE</b> to any message at any time to be unenrolled.
                You will receive a one-time confirmation that you have been
                unsubscribed and will not receive further SMS from the
                Program. To re-enroll later, reply <b>START</b>, <b>YES</b>,
                or <b>UNSTOP</b>, or re-enter your number in the UTSales
                Settings screen.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">6. How to get help (HELP)</h2>
              <p>
                Reply <b>HELP</b> or <b>INFO</b> to any message for help. You
                may also contact us directly at{' '}
                <a href="mailto:john@adamsfirst.com" className="text-crimson hover:underline">
                  john@adamsfirst.com
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">7. Carrier disclaimer</h2>
              <p>
                Carriers are not liable for delayed or undelivered messages.
                Delivery of messages is subject to the effective transmission
                from your wireless carrier and is not guaranteed.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">8. Privacy and data sharing</h2>
              <p className="font-semibold">
                We do not share, sell, rent, or release mobile phone numbers
                or SMS opt-in data to any third party or affiliate for
                marketing or promotional purposes.
              </p>
              <p className="mt-2">
                Mobile information is used solely to deliver the Program&apos;s
                notifications and is shared only with our SMS aggregator
                (Twilio) strictly for the purpose of transmitting messages
                you have opted in to receive. For full details, see our{' '}
                <Link to="/privacy" className="text-crimson hover:underline">
                  Privacy Policy
                </Link>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">9. Eligibility</h2>
              <p>
                The Program is offered only to UTofCA employees authorized to
                use the UTSales application. By enrolling, you represent that
                you are the subscriber or authorized user of the mobile
                number you provide and that you are at least 18 years old.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">10. Changes to these terms</h2>
              <p>
                We may modify or terminate the Program or these terms at any
                time, with or without notice. Material changes will be
                communicated through the Service or by SMS prior to taking
                effect.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">11. Contact</h2>
              <p>
                John Adams &amp; Associates LLC<br />
                Email:{' '}
                <a href="mailto:john@adamsfirst.com" className="text-crimson hover:underline">
                  john@adamsfirst.com
                </a>
              </p>
            </section>
          </div>

          <div className="mt-6 text-center text-sm">
            <Link to="/privacy" className="text-navy hover:underline">Privacy Policy</Link>
            <span className="text-muted mx-2">·</span>
            <Link to="/login" className="text-navy hover:underline">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
